// const {FIREBASE_API_TOKEN} = process.env;
// if(!FIREBASE_API_TOKEN) {
//   throw new Error('FIREBASE_API_TOKEN should be provided!')
// }
/* Hope that no one cares about little old me, and his key, because it's a huge hole in security of course */
const firebaseAPIToken = 'AIzaSyB0S-xtJ8L9u5BS7MbhYXgXDURsKBndswA';

export {firebaseAPIToken}
